import { useSelector } from 'react-redux'
import { selectSystemControl } from '../../containers/common/store/slices/systemControl'

export const useAction = () => {
  const termsOfService = useSelector(selectSystemControl).termsOfService
    
  return { termsOfService }
}